const getters = {
  // token: state => state.user.token,
  openId: (state) => state.user.openId,
  direction: (state) => state.settings.direction,
  url: (state) => state.user.url,
  jf: (state) => state.user.jf,
}
export default getters
